// ============================================================================
// Cliente API para /api/cortesias — trackeo de items regalados.
// ============================================================================
import { api } from './client';

export interface CortesiaRow {
  id: number;
  nombre: string;
  cantidad: number;
  valor_cortesia: number;
  cortesia_at: string;
  usuario: string | null;
  /** A nombre de quién quedó la cortesía (ago-2026); null = del mismo `usuario`. */
  a_nombre_de: string | null;
  pedido_id: number;
  referencia: string;
  pedido_estado: string;
  venta_id: number | null;
  /** "PREF-123" si el pedido ya se facturó; null si no. */
  factura: string | null;
}

export interface CortesiasResponse {
  items: CortesiaRow[];
  resumen: { cantidad: number; valor: number };
}

export const listCortesias = (q: {
  sede_id: number;
  desde?: string;
  hasta?: string;
  /** Filtra por persona: quien registró la cortesía O a nombre de quién quedó. */
  usuario_id?: number;
  limit?: number;
}) => {
  const p = new URLSearchParams({ sede_id: String(q.sede_id) });
  if (q.desde) p.set('desde', q.desde);
  if (q.hasta) p.set('hasta', q.hasta);
  if (q.usuario_id) p.set('usuario_id', String(q.usuario_id));
  if (q.limit) p.set('limit', String(q.limit));
  return api.get<CortesiasResponse>(`/api/cortesias?${p}`);
};
